import urls from './restConstants';
import api from './restApi';

const linksCollection = api.all(urls.links);
export const linkCollection = linkId => api.one(urls.links, linkId);

export default linksCollection;



// WEBPACK FOOTER //
// ./shared/src/rest/linksRest.js